import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/mutualfund/transactions/order/confirmed';
}

/**
 *
 * @param {string} url
 * @returns
 */

function callbackFetch(url, size) {
  return async ({ pageParam = 1 }) => {
    try {
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          page_size: size,
        },
      });

      return res;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}
export default function getV1MFHistory({ pageSize = 20 } = {}) {
  const url = getUrl();
  const cb = callbackFetch(url, pageSize);
  const key = [url, pageSize];

  return { cb, key };
}
